import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function SettingsTab() {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api
      .get("/admin/settings")
      .then((r) => setForm(r.data))
      .catch((e) => {
        if (e?.response?.status === 401) window.location.reload();
        else toast.error(formatApiError(e));
      });
  }, []);

  const setField = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/settings", form);
      toast.success("Configurações salvas. Novos pedidos já recebem os dados atualizados por e-mail.");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSaving(false);
    }
  };

  if (!form) {
    return (
      <div className="flex justify-center py-20">
        <Loader2 className="h-6 w-6 animate-spin text-ink-3" data-testid="admin-settings-loading" />
      </div>
    );
  }

  const inputCls =
    "w-full rounded-xl border border-input bg-white px-4 py-3 text-sm outline-none focus:border-accent";

  return (
    <div className="max-w-lg" data-testid="admin-settings-form">
      <div className="flex flex-col gap-5">
        <div>
          <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-3">
            Número de contato (WhatsApp) — enviado por e-mail ao cliente
          </label>
          <input
            data-testid="admin-settings-whatsapp-input"
            placeholder="ex: (11) 91234-5678"
            value={form.contact_whatsapp}
            onChange={setField("contact_whatsapp")}
            className={`${inputCls} mt-2`}
          />
        </div>
        <div>
          <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-3">Chave Pix (copia e cola)</label>
          <input
            data-testid="admin-settings-pix-input"
            placeholder="Sua chave Pix"
            value={form.pix_key}
            onChange={setField("pix_key")}
            className={`${inputCls} mt-2`}
          />
        </div>
        <div>
          <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-3">Instagram</label>
          <input
            data-testid="admin-settings-instagram-input"
            value={form.instagram}
            onChange={setField("instagram")}
            className={`${inputCls} mt-2`}
          />
        </div>
        <button
          data-testid="admin-settings-save-button"
          onClick={save}
          disabled={saving}
          className="btn-lift flex w-fit items-center gap-2 rounded-full bg-ink px-8 py-3.5 font-mono text-[10px] uppercase tracking-[0.2em] text-paper hover:bg-accent disabled:opacity-60"
        >
          {saving && <Loader2 className="h-4 w-4 animate-spin" />}
          Salvar configurações
        </button>
      </div>
    </div>
  );
}
